

<template>
  <div v-if="isMobile != 0">
    <pc-view v-if="isMobile == 1"></pc-view>
    <mobile-view v-else></mobile-view>
  </div>
</template>
<script>
import pcView from '@/components/Home/Pc.vue'
import mobileView from '@/components/Home/Mobile.vue'
  export default {
    name:"Home",
    components:{
      pcView,
      mobileView
    },
    data(){
      return {

      }
    },
    watch:{
      '$route': {
        immediate: true,
        handler(to, from) {
          if(to.name == 'Home'){
            this.$store.dispatch('setPageCurrentIndex',0)
          }
        }
      }
    },
    computed:{
      isMobile(){
        return this.$store.getters.isMobile;
      }
    },
    created(){
      this.$store.dispatch('setPageCurrentIndex',0)
      // this.getHomeData()
    },
    methods:{
      async getHomeData(){
        let {data} = await this.$api.getData('home',{test:1})
        await this.$store.dispatch('setStoreByKeyData', {key: 'setHomeData', data: data})
      }
    }
  }
</script>
<style scoped lang="scss">
</style>
